const data = {
    "videoUrl": "https://coresource.zhanhuo.com/video/2251kv1.mp4"
}
export default data